var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3 bg-white"
  }, [_c('table', {
    staticClass: "w-100 table table-striped table-hover"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.items, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.trans_id))]), _c('td', [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('img', {
      staticClass: "rounded-circle mr-2",
      attrs: {
        "src": item.avatar,
        "alt": "avatar",
        "width": "40",
        "height": "40"
      }
    }), _c('div', [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.name))]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(item.position))])])])]), _c('td', [_vm._v(_vm._s(item.effective_date))]), _c('td', [_c('span', {
      staticClass: "badge badge-success p-2"
    }, [_vm._v(_vm._s(item.status))])]), _c('td', [_c('button', {
      staticClass: "btn btn-outline-primary btn-sm",
      on: {
        "click": function click($event) {
          _vm.showSidebar = true;
        }
      }
    }, [_vm._v("Detail")])])]);
  }), 0)]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Total Rows: "), _c('strong', {
    staticClass: "text-black"
  }, [_vm._v(_vm._s(5))])]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-form-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": _vm.fetchData
    }
  }), _c('b-pagination', {
    staticClass: "mb-0 ml-2",
    attrs: {
      "total-rows": 10,
      "per-page": 10,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": function change(page) {
        _vm.fetchData();
      }
    }
  })], 1)]), _c('b-sidebar', {
    attrs: {
      "width": "840px",
      "right": "",
      "title": "Detail Adjustment Running Hours",
      "backdrop": "",
      "header-class": "bg-white",
      "body-class": "p-3",
      "no-close-on-backdrop": ""
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('FormAdjustmentRunningHours', {
    attrs: {
      "selectedData": {}
    }
  })], 1)])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("TRANS. ID")]), _c('th', [_vm._v("CREATOR BY")]), _c('th', [_vm._v("EFFECTIVE DATE")]), _c('th', [_vm._v("STATUS")]), _c('th', [_vm._v("ACTION")])])]);

}]

export { render, staticRenderFns }